// extracted by mini-css-extract-plugin
module.exports = {"container":"_solidheader_container__1Y78Z"};